// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bodyText = "Text__bodyText__20Sxx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const bold = "700";
export const captionText = "Text__captionText__fIfkl font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const externalPageHeading = "Text__externalPageHeading__Lz1+g font-faces__serifMedium__n-4rV font-faces__serif__XseuP";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const homepageText = "Text__homepageText__1LtDw font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const medium = "500";
export const moduleSubtitle = "Text__moduleSubtitle__IuUok font-faces__sansBold__vF+EN font-faces__sans__uCf65";
export const moduleTitle = "Text__moduleTitle__lfBQF font-faces__sansBold__vF+EN font-faces__sans__uCf65";
export const pageHeading = "Text__pageHeading__2kw3m font-faces__serifMedium__n-4rV font-faces__serif__XseuP";
export const popupTitle = "Text__popupTitle__Li6DT font-faces__atlasGroteskMedium__1ilbx font-faces__atlasGrotesk__rYPJr";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const smallHeading = "Text__smallHeading__FbnEg font-faces__serifMedium__n-4rV font-faces__serif__XseuP font-faces__serifMedium__n-4rV font-faces__serif__XseuP";
export const smallestHeading = "Text__smallestHeading__1t7of font-faces__serifMedium__n-4rV font-faces__serif__XseuP";